import { render, staticRenderFns } from "./ReleaseBundleEditor.vue?vue&type=template&id=58d15f18&scoped=true"
import script from "./ReleaseBundleEditor.vue?vue&type=script&lang=js"
export * from "./ReleaseBundleEditor.vue?vue&type=script&lang=js"
import style0 from "./ReleaseBundleEditor.vue?vue&type=style&index=0&id=58d15f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d15f18",
  null
  
)

export default component.exports